import axios from "axios";

const baseUrl = `${process.env.REACT_APP_AUTHENTICATION_SERVICE_URL}/`;

const service = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
});

export const fetchData = (url, options) => {
    return service.get(url, options);
};

export const postData = (url, data, options) => {
    return service.post(url, data, options);
};

export const putData = (url, data, options) => {
    return service.put(url, data, options);
};

export const signIn = (applicationId, email, password, authenticationToken) => {
    return service.post("/accounts/authenticate", {
        applicationId,
        email,
        password,
        token: authenticationToken,
    });
};

export const signOut = () => {
    return service.post("/accounts/revoke-token");
};

const api = {
    fetchData,
    postData,
    putData,
    signIn,
    signOut,
};

export default api;
